import { useCallback, useMemo } from 'react';
import { navigate, useLocation } from '@/features/routing';
import { showFullScreenLoadingIndicator } from '../../components/FullScreenLoadingIndicator';
import { parsePathname } from '../../features/routing/utils';

export interface IFormFlowConfig {
  baseUrl: string;
}

export interface IFormFlowActions {
  /** Finish the flow: remove the form pages from history, then push the finish href. */
  finish: (finishHref: string) => void;
}

export const useFormFlowActions = (config: IFormFlowConfig): IFormFlowActions => {
  const pathname = useLocation();

  const stepFromUrl = useMemo(() => {
    return parsePathname(pathname).stepNumber;
  }, [pathname]);

  const finish = useCallback(
    (targetHref: string) => {
      showFullScreenLoadingIndicator();

      // If not in a step URL, just navigate directly.
      if (!stepFromUrl || stepFromUrl <= 0) {
        navigate(targetHref);
        return;
      }

      // Mark completion to let the popstate handler push the finish href.
      sessionStorage.setItem('formFinishLocation', targetHref);

      // Go back N entries to where the user entered the flow.
      history.go(-stepFromUrl);
    },
    [config.baseUrl, navigate, stepFromUrl]
  );

  return { finish };
};
